"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInteger = exports.findIndex = void 0;

var findIndex = function findIndex(array, predicate) {
  var firstIndex = null;
  array.forEach(function (item, index) {
    if (predicate(item) && firstIndex === null) {
      firstIndex = index;
    }
  });
  return firstIndex;
};

exports.findIndex = findIndex;

var isInteger = function isInteger(value) {
  return Number.isInteger(value);
};

exports.isInteger = isInteger;